export type KnownCustomField = {
  systemKey: string;
  systemLabel: string;
  defaultName: string;
  entityType: string;
  fieldType: string;
};

export const KNOWN_CUSTOM_FIELDS: KnownCustomField[] = [
  {
    systemKey: 'inventory_name',
    systemLabel: 'Inventory Name',
    defaultName: 'Inventory Name',
    entityType: 'Inventory',
    fieldType: 'text'
  }
];
